let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ie8yF")).then(() => parcelRequire('135mT'));